export const employees = {
  denis: {
    name: "Denis Bernaerts",
    title: "CEO - SALES",
    email: "mailto:denis@widepack.be",
    email_show: "denis @ widepack.be",
    phone: "tel:+32494631991",
    phone_show: "M +32 494 63 19 91",
  },
  mario: {
    name: "Mario Devroye",
    title: "SALES",
    email: "mailto:mario@widepack.be",
    email_show: "mario @ widepack.be",
    phone: "tel:+32473273506",
    phone_show: "M. +32 473 27 35 06",
  },
  filip: {
    name: "Filip Horemans",
    title: "SALES",
    email: "mailto:filip@widepack.be",
    email_show: "filip @ widepack.be",
    phone: "tel:+32473348390",
    phone_show: "M. +32 473 34 83 90",
  },
};
